<template>
    <v-card :height="isMobile ? height : height - 100">
      <v-system-bar dark color="error" lights-out v-if="!searchCodClienteFlag">
        <v-icon> fa-solid fa-xmark </v-icon>
        <v-spacer></v-spacer>
        No hay talonarios asignados al usuario
      </v-system-bar>
  
      <v-app-bar color="white" elevate-on-scroll flat>
        <v-spacer></v-spacer>
        <div v-if="showSearchCliente">
          <v-text-field
            outlined
            dense
            v-model="searchCodCliente"
            @click:prepend="toggleSearchType"
            @click:append="clearSearchCliente"
            :disabled="!searchCodClienteFlag"
            :label="
              typeSearchCliente ? 'Búsqueda por código' : 'Búsqueda por nombre'
            "
            color="icons"
            hide-details
            append-icon="fa-solid fa-xmark"
            :prepend-icon="
              typeSearchCliente ? 'fa-solid fa-list-ol' : 'fa-solid fa-user'
            "
            hint="Pulse el botón a la izquierda para cambiar el tipo de búsqueda"
          ></v-text-field>
        </div>
        <div v-else>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="toggleSearchCliente"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark>
                  {{ showSearchCliente ? "search_off" : "search" }}
                </v-icon>
              </v-btn>
            </template>
            <span>
              {{
                showSearchCliente
                  ? "Ocultar filtros de búsqueda"
                  : "Mostrar filtros de búsqueda"
              }}
            </span>
          </v-tooltip>
        </div>
      </v-app-bar>
  
      <v-progress-linear
        :active="loadCliente"
        :indeterminate="loadCliente"
        absolute
        top
        color="primary"
      ></v-progress-linear>
  
      <v-sheet
        class="overflow-y-auto"
        :max-height="isMobile ? height - 120 : height - 120"
      >
        <v-card class="mx-auto" :max-width="width">
          <v-list two-line>
            <v-list-item-group
              v-model="selectedCliente"
              active-class="blue--text"
            >
              <v-virtual-scroll
                :items="dtCliente"
                :height="height - 150"
                item-height="110"
              >
                <template v-slot:default="{ item }">
                  <v-list-item :key="item.id">
                    <template v-slot:default="{ active }">
                      <v-list-item-action v-if="item.cantidad_documento > 0">
                        <v-badge color="error" :content="item.cantidad_documento">
                          <v-icon> fa-solid fa-store </v-icon>
                        </v-badge>
                      </v-list-item-action>
                      <v-list-item-avatar v-else>
                        <v-icon> fa-solid fa-store </v-icon>
                      </v-list-item-avatar>
  
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">
                          {{ item.codigo }}
                        </v-list-item-title>
                        <v-list-item-title class="font-weight-bold">
                          {{ item.descripcion }}
                        </v-list-item-title>
  
                        <v-list-item-subtitle class="caption">
                          {{ item.razon_social }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="caption">
                          Nit: {{ item.nit }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="caption">
                          Sucursal: {{ item.departamento }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
  
                      <v-list-item-action>
                        <v-list-item-action-text v-if="active">
                          <v-btn
                            class="mx-2"
                            fab
                            dark
                            x-small
                            color="secondary"
                            @click="showListRecibo(active, item)"
                          >
                            <v-icon dark> fa-solid fa-list-ul </v-icon>
                          </v-btn>
  
                          <v-btn
                            v-if="item.cantidad_valor_doc > 0"
                            class="mx-2"
                            fab
                            dark
                            x-small
                            color="primary"
                            @click="addValor('T', item)"
                          >
                            <v-badge
                              color="error"
                              :content="item.cantidad_valor_doc"
                            >
                              <v-icon dark
                                >fa-solid fa-money-bill-transfer
                              </v-icon>
                            </v-badge>
                          </v-btn>
                          <v-btn
                            v-else
                            class="mx-2"
                            fab
                            dark
                            x-small
                            color="primary"
                            @click="addValor('T', item)"
                          >
                            <v-icon dark
                              >fa-solid fa-money-bill-transfer
                            </v-icon>
                          </v-btn>
                          <v-btn
                            class="mx-2"
                            fab
                            dark
                            small
                            color="success"
                            @click="addRecibo(item)"
                          >
                            <v-icon dark>fa-solid fa-plus </v-icon>
                          </v-btn>
                        </v-list-item-action-text>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </template>
              </v-virtual-scroll>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-sheet>
    </v-card>
  </template>
  
  <script>
  export default {
    props: {
      isMobile: {
        type: Boolean,
        required: true,
      },
      height: {
        type: Number,
        required: true,
      },
      width: {
        type: Number,
        required: true,
      },
      searchCodClienteFlag: {
        type: Boolean,
        required: true,
      },
      showSearchCliente: {
        type: Boolean,
        required: true,
      },
      searchCodCliente: {
        type: String,
        required: true,
      },
      dtCliente: {
        type: Array,
        required: true,
      },
      loadCliente: {
        type: Boolean,
        required: true,
      },
      selectedCliente: {
        type: Array,
        required: true,
      },
      typeSearchCliente: {
        type: Boolean,
        required: true,
      },
    },
    methods: {
      toggleSearchType() {
        this.$emit("toggle-search-type");
      },
      clearSearchCliente() {
        this.$emit("clear-search");
      },
      toggleSearchCliente() {
        this.$emit("toggle-search-cliente");
      },
      showListRecibo(active, item) {
        this.$emit("show-list-recibo", active, item);
      },
      addValor(type, item) {
        this.$emit("add-valor", type, item);
      },
      addRecibo(item) {
        this.$emit("add-recibo", item);
      },
    },
    watch: {
      typeSearchCliente: function (val) {
        this.countCharCliente = this.searchCodCliente.length;
  
        if (this.countCharCliente > 0) {
          this.loadCliente = true;
          this.listCliente();
        }
      },
  
      searchCodCliente: function (val) {
        if (!this.awaitingSearchCliente) {
          setTimeout(() => {
            this.countCharCliente = this.searchCodCliente.length;
  
            if (this.countCharCliente > 0) {
              this.loadCliente = true;
              this.listCliente();
            }
            this.awaitingSearchCliente = false;
          }, 0); // 1 sec delay
        }
        this.awaitingSearchCliente = true;
      },
  
      
    },
  };
  </script>